import React, {
  Component,
  FunctionComponent,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { DateTime } from 'luxon';
import ReactDatePicker from 'react-datepicker';
// import flatpickr from 'flatpickr';
// import flatpickrZHTW from 'flatpickr/dist/l10n/zh-tw';
// import 'flatpickr/dist/flatpickr.min.css';

// export const DATETIME_FORMAT_WITH_TIME = 'Y/m/d H:i';
// export const DATETIME_FORMAT = 'Y/m/d';

export const DATETIME_FORMAT_WITH_TIME = 'yyyy/MM/dd HH:mm';
export const DATETIME_FORMAT = 'yyyy/MM/dd';

type Props = {
  className?: string;
  containerClass?: string;
  format?: typeof DATETIME_FORMAT_WITH_TIME | typeof DATETIME_FORMAT;
  start?: DateTime;
  end?: DateTime;
  disabled?: boolean;
  showTimeSelect?: boolean;
  value?: DateTime;
  onChange: (v: DateTime) => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

// export class DateTimePicker extends Component<Props> {
//   private ref: React.RefObject<HTMLInputElement>;
//   private instance: flatpickr.Instance | null = null;

//   constructor(props: Props) {
//     super(props);
//     this.ref = React.createRef();
//   }

//   componentDidMount() {
//     if (this.ref.current) {
//       this.createFlatpickr(this.ref.current);
//     }
//   }

//   componentDidUpdate(prevProps: Props) {
//     if (this.props.value !== prevProps.value) {
//       this.props.value &&
//         this.instance &&
//         this.instance.setDate(this.props.value?.toJSDate());
//     }
//     if (!this.props.value) {
//       this.instance && this.instance.clear();
//     }
//   }

//   componentWillUnmount() {
//     this.instance && this.instance.destroy();
//   }

//   createFlatpickr = (node: HTMLElement | null) => {
//     if (!node) return;
//     this.instance && this.instance.destroy();
//     const {
//       showTimeSelect,
//       start,
//       end,
//       format = DATETIME_FORMAT,
//       value,
//       onChange,
//       onFocus,
//       onBlur,
//     } = this.props;

//     const option = {
//       enableTime: showTimeSelect,
//       minDate: start?.toJSDate(),
//       maxDate: end?.toJSDate(),
//       dateFormat: format,
//       time_24hr: true,
//       onChange: (dates, currentDateString, self) => {
//         if (dates.length > 0) {
//           const dt = DateTime.fromJSDate(dates[0]);
//           if (dt.isValid) onChange(dt);
//         }
//       },
//       onOpen: () => onFocus && onFocus(),
//       onClose: () => onBlur && onBlur(),
//       locale: flatpickrZHTW.zh_tw,
//       appendTo: node.parentElement?.closest('.modal') ?? undefined,
//       // static: true,
//     } as flatpickr.Options.Options;
//     if (value && value instanceof DateTime && value.isValid) {
//       option.defaultDate = value.toJSDate();
//     }

//     this.instance = flatpickr(node, option);
//   };

//   render() {
//     const { className, disabled } = this.props;
//     return (
//       <input
//         ref={this.ref}
//         type="date"
//         className={['form-control', className].join(' ')}
//         disabled={disabled}
//       />
//     );
//   }
// }

export const DateTimePicker: FunctionComponent<Props> = ({
  className,
  containerClass,
  format = DATETIME_FORMAT,
  start,
  end,
  disabled,
  showTimeSelect,
  value,
  onChange,
  onFocus,
  onBlur,
}) => {
  return (
    <ReactDatePicker
      disabled={disabled}
      className={['form-control', className, containerClass].join(' ')}
      dateFormat={format}
      minDate={start?.toJSDate()}
      maxDate={end?.toJSDate()}
      showTimeInput={showTimeSelect}
      selected={value ? value.toJSDate() : undefined}
      onFocus={(e) => onFocus && onFocus()}
      onBlur={(e) => onBlur && onBlur()}
      // locale="zh-TW"
      portalId="root-portal"
      onChange={(date) => {
        if (date instanceof Date) {
          onChange(DateTime.fromJSDate(date));
        }
      }}
    />
  );
};
